import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
// import { trpc } from '../../trpc';
import { LoaderCircle } from 'lucide-react';
// import { toast } from 'sonner';

// Simple route without authentication checks that might redirect
export const Route = createFileRoute('/evaluate/$applicationId')({
  component: EvaluateResumePage,
});

function EvaluateResumePage() {
  const { applicationId } = Route.useParams();
  const appIdNum = parseInt(applicationId, 10);
  const navigate = useNavigate();

  // console.log('*** Evaluate Resume Page - Application ID:', appIdNum);

  // We don't use this mutation anymore - everything is handled by /evaluation route
  // Just define a dummy object to prevent errors
  // const evaluateMutation = {
  //   isLoading: false,
  //   isSuccess: false,
  //   isError: false,
  //   error: null,
  //   data: null,
  //   mutate: () => {
  //     console.error(
  //       'This mutation should never be called - using redirection instead'
  //     );
  //   },
  // };

  // Check if this is a redirect from a recent evaluation
  const searchParams = new URLSearchParams(window.location.search);
  const isFromDialog = searchParams.get('fromDialog') === 'true';
  const evaluationType = searchParams.get('type'); // 'new' or 're-evaluate'

  // Redirect to the new evaluation route instead of calling the API directly
  useEffect(() => {
    if (!isNaN(appIdNum)) {
      console.log(
        'Redirecting to the new evaluation route for application:',
        appIdNum
      );

      // Record the source for analytics
      const source = isFromDialog ? 'dialog' : 'direct';
      const type = evaluationType || 'unknown';
      console.log(`Evaluation source: ${source}, type: ${type}`);

      // Redirect to the unified evaluation route using router navigation
      navigate({
        to: '/evaluation',
        search: { applicationId: appIdNum.toString() },
        replace: true, // Use replace to avoid adding to history
      });
    }
  }, [appIdNum, isFromDialog, evaluationType, navigate]);

  // Show redirecting state
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4'>
      <div className='max-w-md w-full bg-white p-8 rounded-lg shadow-sm border'>
        <div className='flex justify-center mb-6'>
          <LoaderCircle className='h-12 w-12 text-indigo-600 animate-spin' />
        </div>
        <h1 className='text-xl font-semibold text-center mb-2'>
          Redirecting...
        </h1>
        <p className='text-gray-600 text-center mb-6'>
          Please wait while we redirect you to the evaluation page.
        </p>
      </div>
    </div>
  );
}
